//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
const commonMessages = [
    {
        "Key": "AllPages.ErrorAlertMessage",
        "Phrase": "An error has occurred, please try after sometime"
    }
];

export { commonMessages };
